import { CookieXSRFStrategy } from '@angular/http';

export function XSRFProvider () {
  return  new CookieXSRFStrategy('csrftoken', 'X-CSRFToken');
};



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/xsrf.provider.ts